import React from 'react';
const painPoints = [{
  icon: '😤',
  title: 'Publicás y nadie compra',
  desc: 'Subís fotos del producto con el precio y lo único que llega son likes de tus amigos.'
}, {
  icon: '🤷',
  title: 'No sabés qué publicar',
  desc: 'Abrís Instagram y te quedás en blanco. No tenés idea qué decir para que la gente compre.'
}, {
  icon: '💸',
  title: 'Boosteaste y perdiste plata',
  desc: 'Pusiste plata en publicidad, llegaron visitas, pero nadie compró. No entendés por qué.'
}, {
  icon: '📉',
  title: 'Sin estrategia, sin constancia',
  desc: 'Publicás una semana y desaparecés dos. Tu cuenta no crece y el algoritmo te penaliza.'
}, {
  icon: '👀',
  title: 'Ves cuentas que crecen y no entendés cómo',
  desc: 'Otras marcas con productos similares venden todo el tiempo. Vos no sabés qué hacen diferente.'
}, {
  icon: '📱',
  title: 'Tips de Instagram que no sirven',
  desc: 'Seguís "gurús" de marketing, hacés lo que dicen y nada cambia. La teoría no se traduce en ventas.'
}, {
  icon: '🗣️',
  title: 'No sabés cómo cerrar ventas por DM',
  desc: 'Te preguntan el precio, respondés, y ahí termina la conversación. No sabés cómo convencer.'
}, {
  icon: '📅',
  title: 'Fin de mes sin ventas nuevas',
  desc: 'Tus ventas dependen del boca a boca. No tenés un sistema que traiga compradores todos los días.'
}];
export function PainPoints() {
  return <section className="py-20 bg-white px-4" data-id="element-203">
      <div className="max-w-6xl mx-auto" data-id="element-204">
        <h2 className="text-3xl md:text-4xl font-bold text-navy text-center mb-16 max-w-3xl mx-auto" data-id="element-205">
          Si tenés un emprendimiento y usás redes, esto te pasa
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-206">
          {painPoints.map((point, idx) => <div key={idx} className="bg-slate-50 p-6 rounded-2xl border border-slate-100 hover:border-sky/30 transition-colors" data-id="element-207">
              <div className="text-4xl mb-4" data-id="element-208">{point.icon}</div>
              <h3 className="font-bold text-navy text-lg mb-2" data-id="element-209">
                {point.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-210">
                {point.desc}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-211">
          <h3 className="text-2xl md:text-3xl font-bold text-navy max-w-2xl mx-auto" data-id="element-212">
            ¿Cuántos meses más vas a seguir publicando sin ver resultados?
          </h3>
        </div>
      </div>
    </section>;
}